/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React, { useEffect, useState } from "react";
import { isArrayEmpty } from "cms/utils/empty-exists";
import { useImageLoader } from "cms/components/hero-carousel/use-image-map-loader";
import { HeroSlide } from "./hero-slide";
import { EmptyHeroSlide } from "./empty-hero-slide";

const Hero = (props) => {

    const { component } = props;
    const {
        getImageData,
        preloadImageArray,
        preloadImage,
    } = useImageLoader();
    const slides = component?.slides ?? [];
    const imagePosition = component?.image_position;

    const [index, setIndex] = useState(0);
    const [images, setImages] = useState(null);
    const [foregroundImages, setforegroundImages] = useState(null);

    const hasContent = !isArrayEmpty(slides);
    const total = slides?.length ?? 0;

    const buildSlidesData = async (slides) => {
        if (!slides) {
            return;
        }
        // main images
        const datas = [];
        const firstImage = slides[0]?.image?.image;
        if (firstImage) {
            const first_data = await getImageData(firstImage);
            const first_image = await preloadImage(first_data);
            setImages([first_image]);
        }

        // foreground images
        const foregroundImagesData = [];
        const foreImage = slides[0]?.foreground_image?.image;
        if (foreImage) {
            const first_foreground_image_data = await getImageData(foreImage);
            const first_foreground_image = await preloadImage(first_foreground_image_data);
            setforegroundImages([first_foreground_image]);
        }

        try {
            for (const slide of slides) {
                const image = slide?.image ?? {};
                const image_guid = image?.image ?? "";
                if (image_guid) {
                    const data = await getImageData(image_guid);
                    datas.push(data);
                }

                const foregroundImage = slide?.foreground_image ?? {};
                const foreground_image_guid = foregroundImage?.image ?? "";
                if (foreground_image_guid) {
                    const data = await getImageData(foreground_image_guid);
                    foregroundImagesData.push(data);
                }
            }
            const images = await preloadImageArray(datas);
            setImages(images);
            const foregroundImages = await preloadImageArray(foregroundImagesData);
            setforegroundImages(foregroundImages);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        buildSlidesData(slides);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slides]);

    function moveIndex (increment) {
        let idx = index + increment;
        if (idx > slides.length - 1) {
            idx = 0;
        }
        if (idx < 0) {
            idx = slides.length - 1;
        }
        setIndex(idx);
    }

    if (!hasContent) {
        return <EmptyHeroSlide />;
    } else {
        return (
            <HeroSlide
                slides={slides}
                images={images}
                imagePosition={imagePosition}
                foregroundImages={foregroundImages}
                key={index}
                index={index}
                total={total}
                moveIndex={moveIndex}
            />
        );
    }
};

Hero.displayName = "Hero";
export { Hero };
